export const projects = [
  {
    id: 1,
    title: "EcoSmart Dashboard",
    description: "An interactive energy monitoring dashboard built with React and D3.js for visual data representation.",
    image: "https://picsum.photos/seed/dash/800/450",
    tech: ["React", "Tailwind", "Node.js", "D3.js"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Full Stack",
  },
  {
    id: 2,
    title: "StreamLink Platform",
    description: "A real-time video streaming and community chat platform with peer-to-peer connection capabilities.",
    image: "https://picsum.photos/seed/stream/802/452",
    tech: ["Next.js", "MongoDB", "WebRTC", "Socket.io"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Full Stack",
  },
  {
    id: 3,
    title: "DesignCode Portfolio",
    description: "High-performance developer portfolio with advanced glassmorphism and custom scroll animations.",
    image: "https://picsum.photos/seed/port/803/453",
    tech: ["React", "Vite", "Framer Motion", "Tailwind"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Frontend",
  },
  {
    id: 4,
    title: "CloudVault Storage",
    description: "Secure and encrypted cloud storage service for individuals, featuring easy file sharing and version control.",
    image: "https://picsum.photos/seed/cloud/804/454",
    tech: ["React", "Firebase", "AWS S3", "Tailwind"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Full Stack",
  },
  {
    id: 5,
    title: "InsightAPI Backend",
    description: "A robust and secure RESTful API serving analytics data for large-scale marketing applications.",
    image: "https://picsum.photos/seed/api/805/455",
    tech: ["Node.js", "Express", "PostgreSQL", "Redis"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Backend",
  },
  {
    id: 6,
    title: "MERN Inventory System",
    description: "Enterprise-grade inventory management system with automated report generation and auditing.",
    image: "https://picsum.photos/seed/mern/806/456",
    tech: ["MongoDB", "Express", "React", "Node.js"],
    github: "https://github.com",
    demo: "https://example.com",
    category: "Full Stack",
  },
];
